import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Lien de navigation SPA : clic gauche = navigate,
 * clic molette / Ctrl+clic / Cmd+clic = nouvel onglet (comportement navigateur).
 */
export default function NavPageLink({
  to,
  className = '',
  title,
  children,
  onNavigate,
  ...rest
}) {
  const navigate = useNavigate();
  const href = to || '#';

  const handleClick = (e) => {
    // Laisser le navigateur gérer nouvel onglet / molette
    if (e.defaultPrevented) return;
    if (e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    e.preventDefault();
    if (typeof onNavigate === 'function') {
      onNavigate(href, e);
    } else {
      navigate(href);
    }
  };

  return (
    <a
      href={href}
      className={className}
      title={title}
      {...rest}
      onClick={handleClick}
    >
      {children}
    </a>
  );
}
